(async () => {

    const { Core } = await importModule('Core');

    customElements.define('product-options-dropdown', class extends Core {
        elements = {
            dropdown: 'drop-down',
            current: '[data-current]'
        }

        render() {
            this._handleChange();
        }

        _handleChange() {
            this.addEventListener('change', this._onChange.bind(this));
        }

        _onChange({ target }) {
            this.$current.textContent = target.value;
            // Programmatic changes (fit-finder foot write-back) can arrive
            // before the child <drop-down> upgrades — close() then doesn't
            // exist yet, and there's nothing open to close anyway.
            if (this.$dropdown && typeof this.$dropdown.close === 'function') this.$dropdown.close();
        }
    });

})();